<template>
  <el-dialog
    :title="titleDialog"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="onHandleClose"
    width="60%"
    class="dialog"
    center
  >
    <div class="contents" v-loading="dialogLoading">
      <el-table
        :data="tableData"
        height="400"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
      >
        <el-table-column type="index" width="100px" align="center" label="序号">
        </el-table-column>
        <el-table-column
          prop="type_name"
          align="center"
          label="操作事项"
          min-width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.type_name || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          align="center"
          label="备注"
          min-width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.remark || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="create_time"
          align="center"
          label="操作时间"
          min-width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.create_time || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="business_user_name"
          align="center"
          label="操作人"
          min-width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.business_user_name || "-" }}
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-position">
        <el-pagination
          type="primary"
          background
          @size-change="onHandleSizeChange"
          @current-change="onHandleCurrentChange"
          :current-page="formData.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="formData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onHandleClose">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import { getSupplierOperateLog } from "@/api/general/supplier";

export default {
  name: "SupplierLogDialog",
  props: {},
  data() {
    return {
      dialogVisible: false,
      dialogLoading: false,
      titleDialog: "操作记录",
      formData: {
        id: "",
        page: 1,
        pageSize: 10,
      },
      formDataClone: {}, // 复制一份，用于初始化
      tableData: [],
      total: 0,
    };
  },
  methods: {
    /**
     * 初始化
     */
    onInitData(data) {
      this.formDataClone = cloneDeep(this.formData);
      this.formData.id = data.id;
      this.ajaxGetSupplierOperateLog();
      this.dialogVisible = true;
    },
    /**
     * 关闭操作
     */
    onHandleClose() {
      this.formData = {
        ...this.formDataClone,
      };
      this.dialogVisible = false;
    },
    /**
     * 查询列表
     */
    async ajaxGetSupplierOperateLog() {
      this.dialogLoading = true;
      const params = {
        ...this.formData,
      };
      try {
        const { data } = await getSupplierOperateLog(params);
        this.tableData = data.data;
        this.total = data.total;
      } catch (err) {
        console.log("ajax getSupplierOperateLog err", err);
      } finally {
        this.dialogLoading = false;
      }
    },
    /**
     * 每页条数发生改变
     */
    onHandleSizeChange(val) {
      this.formData.pageSize = val;
      this.ajaxGetSupplierOperateLog();
    },
    /**
     * 页码发生改变
     */
    onHandleCurrentChange(val) {
      this.formData.page = val;
      this.ajaxGetSupplierOperateLog();
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog {
  .contents {
    padding-top: 30px;
    padding-bottom: 20px;
  }
  .tooltip {
    margin-bottom: 30px;
  }
  // /deep/ .el-form {
  // }
  .el-input {
    width: 300px;
  }
}
</style>
